module.exports = __webpack_public_path__ + "static/media/shark-bait.42dd10da.png";